import { Box, Checkbox, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { ConsentContext } from "./provider.js";
import { ConsentInternalApiContext } from "./internal-api.js";
import React from "react";
export const Group = ({ group }) => {
    const theme = useTheme();
    const isAtLeastSm = useMediaQuery(theme.breakpoints.up("sm"));
    const backgroundColor = isAtLeastSm ? "white" : theme.palette.primary.main;
    const color = isAtLeastSm ? theme.palette.primary.dark : "white";
    const borderColor = isAtLeastSm ? "white" : theme.palette.primary.dark;
    const { processes } = React.useContext(ConsentContext);
    const { addGroup, grants, removeGroup } = React.useContext(ConsentInternalApiContext);
    const groupProcessIds = processes
        .filter(({ group: groupId }) => group.id === groupId)
        .map(({ id }) => id);
    const checked = grants.some(({ id }) => groupProcessIds.includes(id));
    const handleChange = (event) => {
        if (event.target.checked) {
            addGroup(group);
        }
        else {
            removeGroup(group);
        }
    };
    return (React.createElement(Box, { component: "li", sx: {
            px: 2,
            py: 1.5,
            backgroundColor,
            border: `1px solid ${borderColor}`,
            color,
            borderRadius: "8px",
        } },
        React.createElement(Stack, { direction: "row", justifyContent: "space-between", alignItems: "center", spacing: 2 },
            React.createElement(Checkbox, { "data-testid": "group-switch", color: isAtLeastSm ? "primary" : "secondary", checked: checked, disabled: group.required, onChange: handleChange, size: "small", sx: isAtLeastSm
                    ? {}
                    : {
                        "&.MuiCheckbox-root": { color: "white" },
                        "&.Mui-disabled": { opacity: 0.5 },
                    } }),
            React.createElement(Box, { sx: { flexGrow: 1, pt: 0.5, pb: 1.5 } },
                React.createElement(Typography, { variant: "h6", role: "heading", component: "div", sx: { pt: 0, pb: 0 } }, group.name),
                React.createElement(Typography, { variant: "caption", component: "div" }, group.description)))));
};
//# sourceMappingURL=group.js.map